import { render, staticRenderFns } from "./Wettbewerb.vue?vue&type=template&id=2684c8ae&scoped=true"
import script from "./Wettbewerb.vue?vue&type=script&lang=js"
export * from "./Wettbewerb.vue?vue&type=script&lang=js"
import style0 from "./Wettbewerb.vue?vue&type=style&index=0&id=2684c8ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2684c8ae",
  null
  
)

export default component.exports